import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { accessToken } from "../accessToken";
import { DeviceService } from "../DeviceService";

const TOKEN_KEY = "push_notification_token";

const initializePushNotifications = async () => {
  try {
    // Request and check permissions
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === "prompt") {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== "granted") {
      throw new Error("User denied permissions!");
    }

    // Register for push notifications
    await PushNotifications.register();

    // Add listeners
    await addListeners();
  } catch (error) {
    console.error("Error initializing push notifications:", error);
  }
};

const addListeners = async () => {
  PushNotifications.addListener("registration", async (token) => {
    const newToken = token.value;
    const oldToken = localStorage.getItem(TOKEN_KEY);

    // Persist the new token before any network calls
    localStorage.setItem(TOKEN_KEY, newToken);

    try {
      if (oldToken && oldToken !== newToken) {
        await DeviceService.unregister(oldToken).catch(console.log);
      }

      if (!accessToken.isExpired()) {
        await DeviceService.register(newToken, Capacitor.getPlatform());
      }
    } catch (err) {
      console.log(err);
    }
  });

  PushNotifications.addListener("registrationError", (err) => {
    console.error("Registration error: ", err.error);
  });

  PushNotifications.addListener("pushNotificationReceived", async (notification) => {
    console.log("Push notification received: ", notification);
    const deliveredNotifications = await getDeliveredNotifications();
    console.log(deliveredNotifications.length);
  });

  PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
    console.log(
      "Push notification action performed",
      notification.actionId,
      notification.inputValue
    );
  });
};

const getDeliveredNotifications = async () => {
  const notificationList = await PushNotifications.getDeliveredNotifications();
  return notificationList;
};

// Called after login/restore to ensure the server has the current device token.
// The FCM registration event may have fired before the access token was available,
// so this covers the "authenticated app launch" moment.
const syncRegistration = async () => {
  if (!Capacitor.isNativePlatform()) return;

  const storedToken = localStorage.getItem(TOKEN_KEY);
  if (!storedToken) return;

  if (accessToken.isExpired()) return;

  await DeviceService.register(storedToken, Capacitor.getPlatform());
};

export const PushNotificationService = {
  initializePushNotifications,
  addListeners,
  getDeliveredNotifications,
  syncRegistration,
};
